import { render, staticRenderFns } from "./BunkeringLogForm.vue?vue&type=template&id=78091b1e"
import script from "./BunkeringLogForm.vue?vue&type=script&lang=js"
export * from "./BunkeringLogForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports